import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { ApplicationType } from '../constants/application-type';
import type { TypeaheadList } from '../components/atoms/typeahead/TypeaheadList';

export class SearchApiSettings {
  baseUrl: string;
  searchTimeOut: number;
  applicationType: ApplicationType;
  b2cFlag: boolean;
}

const createInstance = (settings: SearchApiSettings): AxiosInstance =>
  axios.create({
    baseURL: settings.baseUrl,
    timeout: settings.searchTimeOut,
    method: `GET`,
  });

export const getSearchResults = (
  searchQuery: string,
  signal: AbortSignal,
  settings: SearchApiSettings,
): Promise<AxiosResponse> => {
  const application: ApplicationType = settings.applicationType ?? ApplicationType.IntoStudy;

  const searchServicePath = settings.b2cFlag
    ? `/course/search?application=${application}&${searchQuery}`
    : `/course/search?${searchQuery}`;

  const params: AxiosRequestConfig = {
    url: searchServicePath,
    signal,
  };
  return createInstance(settings).request(params);
};

export type GetSearchSuggestions = typeof getSearchSuggestionsFromApi;

export const getSearchSuggestionsFromApi = (
  query: string,
  signal: AbortSignal,
  settings: SearchApiSettings,
): Promise<TypeaheadList[]> => {
  const params: AxiosRequestConfig = {
    url: `/suggest?keyword=${query}`,
    signal,
  };
  return createInstance(settings)
    .request(params)
    .then((result) => result?.data);
};
